<div class="button_quanity">
  <div class="editor-header" *ngIf="isViewAll" style="cursor: pointer">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{currentViewAll.title | translate}} <span
        style="text-transform: lowercase;">{{fields_style_basic | translate}}</span></span>
  </div>
  <ng-container *ngIf="!isViewAll">
    <app-width-height-config [device]="device" [elementChoosing]="objectChoosing"
      [width]="class['btn-quantity']['width']" [height]="class['btn-quantity']['height']"
      (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>
    <ul nz-menu nzMode="inline">
      <li nz-submenu nzTitle="{{'kich_thuoc' | translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')"
        *ngIf="!config.hidden.hidden_amount">
        <!-- Lựa chọn hiển thị cho các thiết bị -->
        <div class="items">
          <div class="font-size-icon">
            <div class="mt-2 slide-bar">
              <p class="m-0 title">{{'khoang_cach' | translate}} </p>
              <input matInput type="number" class="input-number" [ngModel]="class['btn-quantity']['gap'] | vhnumber"
                (ngModelChange)="class['btn-quantity']['padding'] = $event +'px';">
            </div>
            <div class="font-size">
              <nz-slider [nzMin]="0" [nzMax]="20" [ngModel]="class['btn-quantity']['gap'] | vhnumber"
                (nzOnAfterChange)="updateClass()"
                (ngModelChange)="class['btn-quantity']['gap'] = $event +'px'"></nz-slider>
            </div>
          </div>
          <div class="contains-style">
            <button class="style-item" *ngFor="let basic of configStyleBasic" (click)=" chooseBasic(basic)">
              <span style="font-size: 13px; white-space: nowrap">{{basic.title | translate}}</span>
            </button>
          </div>

        </div>
      </li>
      <!-- CẤU HÌNH MÀU SẮC -->
      <li nz-submenu nzTitle="{{'mau_sac' | translate}}" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
        <div class="contains-color">
          <button class="color-quantity" *ngFor="let style of configStyleBasic" (click)="chooseColor(style)"
            [disabled]="style.title === 'nut_tang_giam' && config.hidden.hidden_amount"
            [ngClass]="{'disable': style.title === 'nut_tang_giam' && config.hidden.hidden_amount}">
            <span style="font-size:13px;white-space: nowrap">{{style.title| translate}}</span>
          </button>
        </div>
      </li>
      <!-- CẤU HÌNH VIỀN -->
      <li nz-submenu nzTitle="{{'duong_vien' | translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <div class="contains-style">
          <button class="style-item" *ngFor="let style of configStyleBasic" (click)="chooseBorder(style)"
            [disabled]="style.title === 'nut_tang_giam' && config.hidden.hidden_amount"
            [ngClass]="{'disable': style.title === 'nut_tang_giam' && config.hidden.hidden_amount}">
            <span style="font-size:13px;white-space: nowrap">{{style.title | translate}}</span>
          </button>
        </div>
      </li>
      <!-- Đường viền chung -->
      <li nz-submenu nzTitle="{{'duong_vien_chung' | translate}}" [(nzOpen)]="openMap.menu7" (nzOpenChange)="openHandler('menu7')">
        <app-borders-config [device]="device" [class]="class" [borderClass]="class['btn-quantity']"
          [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
        </app-borders-config>

        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right">
          <p class="m-0 title-border my-2" (click)="openViewAll(fieldsConfig[5])">
            {{'mo_rong' | translate}} &#8594;
          </p>
        </div>
      </li>
      <!-- CẤU HÌNH BO TRÒN -->
      <li nz-submenu nzTitle="{{'bo_tron' | translate}}" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
        <div class="contains-style">
          <button class="style-item" *ngFor="let style of configStyleBasic" (click)="chooseBorderRadius(style)"
            [disabled]="style.title === 'nut_tang_giam' && config.hidden.hidden_amount"
            [ngClass]="{'disable': style.title === 'nut_tang_giam' && config.hidden.hidden_amount}">
            <span style="font-size:13px;white-space: nowrap">{{style.title| translate}}</span>
          </button>
        </div>
      </li>
      <!-- CẤU HÌNH BIỂU TƯỢNG -->
      <li nz-submenu nzTitle="{{'bieu_tuong' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <div class="contains-icon">
          <button class="icon-quantity" *ngFor="let icon of configStyleIcon" (click)="chooseIcon(icon)"
            [ngClass]="{'disable': config.hidden.hidden_amount}" [disabled]="config.hidden.hidden_amount">
            <span style="font-size:13px;white-space: nowrap">{{icon.title | translate}}</span>
          </button>
        </div>
      </li>
      <!-- CẤU HÌNH NHÃN -->
      <li nz-submenu nzTitle="{{'nhan' | translate}}" [(nzOpen)]="openMap.menu8" (nzOpenChange)="openHandler('menu8')">
        <div [matTooltip]="'*_giai_thich_aria_label' | translate">
          <!-- Nếu nội dung không có thì phải có nhãn -->
          <mat-form-field style="width: 100%" class="aria-label-input">
            <mat-label>{{'nhan_cua_o_nhap' | translate}}<span style="color: red">*</span></mat-label>
            <textarea matInput
              [ngModel]="staticdata?.accessibility?.['aria_label_input_' + functionService.selectedLanguageCode]"
              (ngModelChange)="staticdata.accessibility['aria_label_input_' + functionService.selectedLanguageCode] = $event"
              (blur)="updateStaticData()"></textarea>
          </mat-form-field>
          <ng-container>
            <!-- Nếu nội dung không có thì phải có nhãn -->
            <mat-form-field style="width: 100%; margin-top: 10px" class="aria-label-input">
              <mat-label>{{'nhan_cua_nut_giam' | translate}}<span style="color: red">*</span></mat-label>
              <textarea matInput
                [ngModel]="staticdata?.accessibility?.['aria_label_dec_' + functionService.selectedLanguageCode]"
                (ngModelChange)="staticdata.accessibility['aria_label_dec_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData()"></textarea>
            </mat-form-field>
            <!-- Nếu nội dung không có thì phải có nhãn -->
            <mat-form-field style="width: 100%; margin-top: 10px" class="aria-label-input">
              <mat-label>{{'nhan_cua_nut_tang' | translate}}<span style="color: red">*</span></mat-label>
              <textarea matInput
                [ngModel]="staticdata?.accessibility?.['aria_label_inc_' + functionService.selectedLanguageCode]"
                (ngModelChange)="staticdata.accessibility['aria_label_inc_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData()"></textarea>
            </mat-form-field>
          </ng-container>
        </div>
      </li>
      <!-- CẤU HÌNH THÔNG SỐ CƠ BẢN -->
      <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
        <!-- Lựa chọn {{'hien_thi' | translate}} cho các thiết bị -->
        <div class="items">
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
    </ul>
  </ng-container>
  <div class="view-more" *ngIf="isViewAll">
    <!-- CẤU HÌNH CHI TIẾT THÔNG SỐ CƠ BẢN -->
    <div class="style-basic" *ngIf="currentViewAll.index == 1">
      <div class="field-basic" *ngIf="fields_style_basic == 'nut_tang_giam'">
        <div class="item-basic">
          <div class="slide-bar">
            <p class="m-0 title">{{'chieu_rong' | translate}}</p>
            <input class="input-number" type="text" [ngModel]="class['btn-quantity__amount'].width | vhpercent"
              #widthvalue (ngModelChange)="class['btn-quantity__amount'].width = $event;"
              (blur)="class['btn-quantity__amount'].width = widthvalue.value;updateClass()">
          </div>
          <nz-slider [ngModel]="class['btn-quantity__amount'].width | vhnumber" [nzMin]="1" [nzMax]="100" [nzStep]="1"
            (ngModelChange)="class['btn-quantity__amount'].width = $event+'%';"
            (nzOnAfterChange)="updateClass()"></nz-slider>
        </div>
        <div class="item-basic">
          <div class="slide-bar">
            <p class="m-0 title">{{'chieu_cao' | translate}}</p>
            <input class="input-number" type="text" [ngModel]="class['btn-quantity__amount'].height | vhpercent"
              #heightvalue (ngModelChange)="class['btn-quantity__amount'].height = $event;"
              (blur)="class['btn-quantity__amount'].height = heightvalue.value;updateClass()">
          </div>
          <nz-slider [ngModel]="class['btn-quantity__amount'].height | vhnumber" [nzMin]="1" [nzMax]="100" [nzStep]="1"
            (ngModelChange)="class['btn-quantity__amount'].height = $event+'%';"
            (nzOnAfterChange)="updateClass()"></nz-slider>
        </div>
      </div>
      <div class="field-basic" *ngIf="fields_style_basic == 'o_so_luong'">
        <div class="item-basic">
          <div class="slide-bar">
            <p class="m-0 title">{{'chieu_rong' | translate}}</p>
            <input class="input-number" type="text" [ngModel]="class['btn-quantity__input'].width | vhpercent"
              #widthvalue (ngModelChange)="class['btn-quantity__input'].width = $event;"
              (blur)="class['btn-quantity__input'].width = widthvalue.value;updateClass()">
          </div>
          <nz-slider [ngModel]="class['btn-quantity__input'].width | vhnumber" [nzMin]="1" [nzMax]="100" [nzStep]="1"
            (ngModelChange)="class['btn-quantity__input'].width = $event+'%';"
            (nzOnAfterChange)="updateClass()"></nz-slider>
        </div>
        <div class="item-basic">
          <div class="slide-bar">
            <p class="m-0 title">{{'chieu_cao' | translate}}</p>
            <input class="input-number" type="text" [ngModel]="class['btn-quantity__input'].height | vhpercent"
              #heightvalue (ngModelChange)="class['btn-quantity__input'].height = $event;"
              (blur)="class['btn-quantity__input'].height = heightvalue.value;updateClass()">
          </div>
          <nz-slider [ngModel]="class['btn-quantity__input'].height | vhnumber" [nzMin]="1" [nzMax]="100" [nzStep]="1"
            (ngModelChange)="class['btn-quantity__input'].height = $event+'%';"
            (nzOnAfterChange)="updateClass()"></nz-slider>
        </div>
      </div>
      <div class="field-basic" *ngIf="fields_style_basic == 'Nút tăng'">
        <div class="item-basic">
          <div class="slide-bar">
            <p class="m-0 title">{{'chieu_rong' | translate}}</p>
            <input class="input-number" type="text" [ngModel]="class['btn-quantity__increase-amount'].width | vhpercent"
              #widthvalue (ngModelChange)="class['btn-quantity__increase-amount'].width = $event;"
              (blur)="class['btn-quantity__increase-amount'].width = widthvalue.value;updateClass()">
          </div>
          <nz-slider [ngModel]="class['btn-quantity__increase-amount'].width | vhnumber" [nzMin]="1" [nzMax]="100"
            [nzStep]="1" (ngModelChange)="class['btn-quantity__increase-amount'].width = $event+'%';"
            (nzOnAfterChange)="updateClass()"></nz-slider>
        </div>
        <div class="item-basic">
          <div class="slide-bar">
            <p class="m-0 title">{{'chieu_cao' | translate}}</p>
            <input class="input-number" type="text"
              [ngModel]="class['btn-quantity__increase-amount'].height | vhpercent" #heightvalue
              (ngModelChange)="class['btn-quantity__increase-amount'].height = $event;"
              (blur)="class['btn-quantity__increase-amount'].height = heightvalue.value;updateClass()">
          </div>
          <nz-slider [ngModel]="class['btn-quantity__increase-amount'].height | vhnumber" [nzMin]="1" [nzMax]="100"
            [nzStep]="1" (ngModelChange)="class['btn-quantity__increase-amount'].height = $event+'%';"
            (nzOnAfterChange)="updateClass()"></nz-slider>
        </div>
      </div>
    </div>
    <!-- CẤU HÌNH CHI TIẾT HÌNH DẠNG VIỀN -->
    <div class="style-border" *ngIf="currentViewAll.index == 2">
      <div class="field-border" *ngIf="fields_style_border == 'nut_tang_giam'">
        <app-borders-config [device]="device" [class]="class" [borderClass]="class['btn-quantity__amount']"
          [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
        </app-borders-config>
      </div>
      <div class="field-border" *ngIf="fields_style_border == 'o_so_luong'">
        <app-borders-config [device]="device" [class]="class" [borderClass]="class['btn-quantity__input']"
          [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
        </app-borders-config>
      </div>
    </div>
    <!-- CẤU HÌNH CHI TIẾT MÀU SẮC -->
    <div class="style-color" *ngIf="currentViewAll.index == 3">
      <div class="field-color" *ngIf="fields_style_color == 'nut_tang_giam'">
        <div class="container-color">
          <button id="btn-color" *ngFor="let background of backgroundColor; let i = index"
            [ngStyle]="{'background-color':background.bgColor }" (click)="chooseBg(background, $event)" nz-tooltip>
          </button>
        </div>
        <div class="d-flex align-items-center mt-2">
          <span class="hidden-text mr-2 w-50">{{'chon_mau' | translate}}</span>
          <input class="input-color w-50" type="button"
            [cpOKButton]="true" [(colorPicker)]="class['btn-quantity__amount']['background-color']"
            [style.background]="class['btn-quantity__amount']['background-color']" (colorPickerClose)="updateObject()"
            style="height:30px; width: 60px; border: none; outline: none" />
        </div>

        <!-- Cấu hình chi tiết màu gradient  -->
        <div class="container-gradient">
          <div class="title-head">
            <p class="text-fill">{{'phoi_mau' | translate}}</p>
            <label nz-checkbox [(ngModel)]="config['btn-quantity__amount-gradient'].gradient_check"
              (ngModelChange)="updateBackgroundRgb('amount')"></label>
          </div>
          <ng-container *ngIf="config['btn-quantity__amount-gradient'].gradient_check">
            <div class="list-gradient">
              <button class="btn-gradient" *ngFor="
                  let bgGradient of config['btn-quantity__amount-gradient']['gradient_arr'];
                  let i = index
                " (click)="deleteGradient(i, 'amount')" [ngStyle]="{ 'background-color': bgGradient }"
                [disabled]="!config['btn-quantity__amount-gradient'].gradient_check">
                <i class="delete-icon bi bi-x-circle"></i>
              </button>
            </div>
            <p class="title-head">{{'them_mau' | translate}}</p>
            <div class="container_add-gradient">
              <input class="input-color" [cpOKButton]="true" [(colorPicker)]="class['btn-quantity__amount']['background-color']"
                type="button" [disabled]="!config['btn-quantity__amount-gradient'].gradient_check"
                [style.background]="class['btn-quantity__amount']['background-color']" (colorPickerClose)="addGradient($event, 'amount')" />
            </div>
            <p class="title-head">{{'huong_phoi_mau' | translate}}</p>
            <button class="gradient-direction" *ngFor="let type of typeGradient" nz-tooltip
              nzTooltipTitle="{{type.name | translate}}" (click)="chooseOption(type, $event, 'amount')"
              [disabled]="!config['btn-quantity__amount-gradient'].gradient_check" [style.background]="
                'linear-gradient(' + type.deg + ', #2764EB, #EFE810)'
            "></button>
          </ng-container>
        </div>
      </div>

      <!-- o_so_luong -->
      <div class="field-color" *ngIf="fields_style_color == 'o_so_luong'">
        <div class="container-font">
          <div class="config-font-size">
            <div class="field-row-font" style="width: 65%">
              <mat-form-field style="width: 100%">
                <mat-label>Font</mat-label>
                <mat-select [(ngModel)]="class['btn-quantity__input']['font-family']
              " (ngModelChange)="updateClass()" [(value)]="class['btn-quantity__input']['font-family']">
                  <mat-option *ngFor="let font of fonts" [value]="font.value">{{
                    font.name
                    }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="field-row-size" style="width: 35%">
              <mat-form-field style="width: 100%">
                <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                <input matInput type="number" (blur)="updateClass()" (keyup.enter)="updateClass()" [ngModel]="
                              class['btn-quantity__input']['font-size'] | vhnumber
                            " (ngModelChange)="
                              class['btn-quantity__input']['font-size'] =
                                $event + 'px'
                            " />
              </mat-form-field>
            </div>
          </div>
          <div class="config-font">
            <p class="title-font">{{'kieu_chu' | translate}}</p>
            <div class="field-row">
              <button class="font-text-btn font-text-btn-bold" title="bold" nz-button [nzType]="
                            class['btn-quantity__input']['font-weight'] == 'bold'
                              ? 'primary'
                              : 'default'
                          " (click)="
                            class['btn-quantity__input']['font-weight'] =
                              class['btn-quantity__input']['font-weight'] == 'bold'
                                ? '500'
                                : 'bold';
                            updateClass()
                          ">
                <span style="font-weight: 600">B</span>
              </button>
              <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                            class['btn-quantity__input']['font-style'] == 'italic'
                              ? 'primary'
                              : 'default'
                          " (click)="
                            class['btn-quantity__input']['font-style'] =
                              class['btn-quantity__input']['font-style'] == 'normal'
                                ? 'italic'
                                : 'normal';
                            updateClass()
                          ">
                <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
              </button>
              <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                            class['btn-quantity__input']['text-decoration'] ==
                            'underline'
                              ? 'primary'
                              : 'default'
                          " (click)="
                            class['btn-quantity__input']['text-decoration'] =
                              class['btn-quantity__input']['text-decoration'] ==
                              'none'
                                ? 'underline'
                                : 'none';
                            updateClass()
                          ">
                <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
              </button>
              <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                            class['btn-quantity__input']['text-transform'] ==
                            'uppercase'
                              ? 'primary'
                              : 'default'
                          " (click)="
                            class['btn-quantity__input']['text-transform'] =
                              class['btn-quantity__input']['text-transform'] ==
                              'none'
                                ? 'uppercase'
                                : 'none';
                            updateClass()
                          ">
                <span>AB</span>
              </button>
              <div>
                <input id="color" type="button"  [cpOKButton]="true" [(colorPicker)]="class['btn-quantity__input'].color"
                  [style.background]="class['btn-quantity__input'].color" (colorPickerClose)="updateObject()"
                  [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
              </div>
            </div>
          </div>
        </div>

        <p>{{'mau_nen' | translate}}</p>
        <div class="container-color">
          <button id="btn-color" *ngFor="let background of backgroundColor; let i = index"
            [ngStyle]="{'background-color':background.bgColor }" (click)="chooseBgInput(background, $event)" nz-tooltip>
          </button>
        </div>
        <div class="color-pick d-flex justify-content-between mt-2">
          <span class="hidden-text w-50">{{'chon_mau_nen' | translate}}</span>
          <input class="input-color w-50" type="button"
            [cpOKButton]="true" [(colorPicker)]="class['btn-quantity__input']['background-color']"
            [style.background]="class['btn-quantity__input']['background-color']" (colorPickerClose)="updateObject()"
            [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
        </div>

        <!-- Cấu hình chi tiết màu gradient  -->
        <div class="container-gradient">
          <div class="title-head">
            <p class="text-fill">{{'phoi_mau' | translate}}</p>
            <label nz-checkbox [(ngModel)]="config['btn-quantity__input-gradient'].gradient_check"
              (ngModelChange)="updateBackgroundRgb('input')"></label>
          </div>
          <ng-container *ngIf="config['btn-quantity__input-gradient'].gradient_check">
            <div class="list-gradient">
              <button class="btn-gradient" *ngFor="
                  let bgGradient of config['btn-quantity__input-gradient']['gradient_arr'];
                  let i = index
                " (click)="deleteGradient(i, 'input')" [ngStyle]="{ 'background-color': bgGradient }"
                [disabled]="!config['btn-quantity__input-gradient'].gradient_check">
                <i class="delete-icon bi bi-x-circle"></i>
              </button>
            </div>
            <p class="title-head">{{'them_mau' | translate}}</p>
            <div class="container_add-gradient">
              <input class="input-color" [cpOKButton]="true" [(colorPicker)]="class['btn-quantity__input']['background-color']"
                type="button" [disabled]="!config['btn-quantity__input-gradient'].gradient_check"
                [style.background]="class['btn-quantity__input']['background-color']" (colorPickerClose)="addGradient($event, 'input')" />
            </div>
            <p class="title-head">{{'huong_phoi_mau' | translate}}</p>
            <button class="gradient-direction" *ngFor="let type of typeGradient" nz-tooltip
              nzTooltipTitle="{{type.name | translate}}" (click)="chooseOption(type, $event, 'input')"
              [disabled]="!config['btn-quantity__input-gradient'].gradient_check" [style.background]="
                'linear-gradient(' + type.deg + ', #2764EB, #EFE810)'
            "></button>
          </ng-container>
        </div>
      </div>

    </div>
    <!-- CẤU HÌNH CHI TIẾT ICON -->
    <div class="style-icon" *ngIf="currentViewAll.index == 4">
      <div class="field-icon" *ngIf="fields_style_icon == 'nut_giam'">
        <div class="selectedIcon">
          <div class="ml-3">
            <mat-icon>{{config.icon.icon_minus}}</mat-icon>
          </div>
          <button nz-button nzType="default" (click)="openDialogChooseIcon()">{{'thay_doi' | translate}}</button>
        </div>
        <div class="font-size-icon">
          <div class="mt-2 slide-bar">
            <p class="m-0 title" style="line-height:1.5">{{'kich_thuoc' | translate}}</p>
            <input matInput type="number" class="input-number" (blur)="updateClass()" (keyup.enter)="updateClass()"
              [ngModel]="class['btn-quantity__amount--increase-icon']['font-size'] | vhnumber"
              (ngModelChange)="class['btn-quantity__amount--increase-icon']['font-size'] = $event +'px';">
          </div>
          <div class="font-size">
            <nz-slider [nzMin]="0" [nzMax]="50"
              [ngModel]="class['btn-quantity__amount--increase-icon']['font-size'] | vhnumber"
              (nzOnAfterChange)="updateClass()"
              (ngModelChange)="class['btn-quantity__amount--increase-icon']['font-size'] = $event +'px' "></nz-slider>
          </div>
        </div>
        <div class="item-border">
          <p class="m-0 title w-50" style="line-height:1.5">{{'mau_sac' | translate}}</p>
          <input class="input-color w-50" type="button"
            [cpOKButton]="true" [(colorPicker)]="class['btn-quantity__amount--increase-icon'].color"
            [style.background]="class['btn-quantity__amount--increase-icon'].color" (colorPickerClose)="updateObject()"
            [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
        </div>
      </div>
      <div class="field-icon" *ngIf="fields_style_icon == 'nut_tang'">
        <div class="selectedIcon">
          <div class="ml-3">
            <mat-icon>{{config.icon.icon_plus}}</mat-icon>
          </div>
          <button nz-button nzType="default" (click)="openDialogChooseIcon()">{{'thay_doi' | translate}}</button>
        </div>
        <div class="font-size-icon">
          <div class="mt-2 slide-bar">
            <p class="m-0 title" style="line-height:1.5">{{'kich_thuoc' | translate}}</p>
            <input matInput type="number" class="input-number" (blur)="updateClass()" (keyup.enter)="updateClass()"
              [ngModel]="class['btn-quantity__amount--decrease-icon']['font-size'] | vhnumber"
              (ngModelChange)="class['btn-quantity__amount--decrease-icon']['font-size'] = $event +'px';">
          </div>
          <div class="font-size">
            <nz-slider [nzMin]="0" [nzMax]="50"
              [ngModel]="class['btn-quantity__amount--decrease-icon']['font-size'] | vhnumber"
              (nzOnAfterChange)="updateClass()"
              (ngModelChange)="class['btn-quantity__amount--decrease-icon']['font-size'] = $event +'px'"></nz-slider>
          </div>
        </div>
        <div class="item-border">
          <p class="m-0 title w-50" style="line-height:1.5">{{'mau_sac' | translate}}</p>
          <input class="input-color w-50" type="button"
            [cpOKButton]="true" [(colorPicker)]="class['btn-quantity__amount--decrease-icon'].color"
            [style.background]="class['btn-quantity__amount--decrease-icon'].color" (colorPickerClose)="updateObject()"
            [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
        </div>
      </div>
    </div>
    <!-- CẤU HÌNH CHI TIẾT BO TRÒN -->
    <div class="style-border" *ngIf="currentViewAll.index == 5">
      <div class="field-border mt-1" *ngIf="fields_style_border == 'nut_tang_giam'">
        <app-borders-radius-config [device]="device" [class]="class" [borderRadiusClass]="class['btn-quantity__amount']"
          [id_object]="objectChoosing._id">
        </app-borders-radius-config>
      </div>
      <div class="field-border mt-1" *ngIf="fields_style_border == 'o_so_luong'">
        <app-borders-radius-config [device]="device" [class]="class" [borderRadiusClass]="class['btn-quantity__input']"
          [id_object]="objectChoosing._id">
        </app-borders-radius-config>
      </div>
    </div>
    <!-- CẤU HÌNH CHI TIẾT VIỀN CHUNG -->
    <div class="style-icon" *ngIf="currentViewAll.index == 6">
      <app-borders-radius-config [device]="device" [class]="class" [borderRadiusClass]="class['btn-quantity']"
        [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
  </div>
</div>